import { Button } from '@/components/ui/button'

interface RoleFilterProps {
  roles: string[]
  active: string
  onChange: (role: string) => void
}

export function RoleFilter({ roles, active, onChange }: RoleFilterProps) {
  return (
    <div className="flex flex-wrap gap-2">
      <Button
        size="sm"
        variant={active === 'all' ? 'default' : 'outline'}
        onClick={() => onChange('all')}
      >
        All
      </Button>
      {roles.map((role) => (
        <Button
          key={role}
          size="sm"
          variant={active === role ? 'default' : 'outline'}
          onClick={() => onChange(role)}
        >
          {role}
        </Button>
      ))}
    </div>
  )
}
